import {BASE_URL, getUserName} from '../../../Utils/constants'
import axios from 'axios'
import {
  readGraphDataFromServerType,
  reportListTypeFromServer,
  scheduleReportUploadResponseType,
} from './model'

const GET_SCHEDULED_REPORTS_URL = `${BASE_URL}/ReportChartApp/src/api.php`
const UPLOAD_SCHEDULED_REPORTS_URL = `${BASE_URL}/ReportChartApp/src/api.php`
const GET_GRAPH_DATA_URL = `${BASE_URL}/ReportChartApp/src/api.php`

export const getScheduledReports = () => {
  const userName = getUserName()
  if (!userName) {
    throw new Error('Unauthorized user')
  }
  const url = GET_SCHEDULED_REPORTS_URL
  const request = {
    function: 'getListOfExcelForUserByType',
    reportType: 'schedule',
    username: userName,
  }
  return axios.post<{data: reportListTypeFromServer[]; success: boolean}>(url, request)
}

export const uploadScheduledReport = (file: File) => {
  const userName = getUserName()
  if (!userName) {
    throw new Error('Unauthorized user')
  }
  const url = UPLOAD_SCHEDULED_REPORTS_URL
  const headers = {headers: {'Content-Type': 'multipart/form-data'}}
  const formData = new FormData()
  formData.append('function', 'uploadExcel')
  formData.append('reportType', 'schedule')
  formData.append('username', userName)
  formData.append('file', file)

  return axios.post<scheduleReportUploadResponseType>(url, formData, headers)
}

export const getScheduledGraphData = (reportIds: number[]) => {
  const userName = getUserName()
  if (!userName) {
    throw new Error('Unauthorized user')
  }
  const url = GET_GRAPH_DATA_URL
  const request = {
    function: 'getGraphDataByReportTypeAndDateOrExcelIds',
    reportType: 'schedule',
    username: userName,
    reportIds: [...reportIds],
  }
  return axios.post<readGraphDataFromServerType>(url, request)
}
